import React, { Component } from 'react';
import ClickOutside from 'react-click-outside';
import { ChevronDown, ChevronUp } from 'react-feather';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import './DropdownLink.css';

class DropdownLink extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { hidden: true };
  }

  handleClick = () => {
    this.setState({ hidden: !this.state.hidden });
  };

  handleClose = () => {
    this.setState({ hidden: true });
  };

  renderContent = () => {
    if (this.state.hidden) {
      return;
    }

    return (
      <div className="dropdown-content">
        {this.props.children}
      </div>
    );
  };

  render() {
    return (
      <ClickOutside className="Dropdown"
          onClick={this.handleClick}
          onClickOutside={this.handleClose}
      >
        <a>{getLabel(this.context.locale, this.props.label)}</a>
        {this.renderContent()}
        {this.state.hidden ? <ChevronDown size={12}/> : <ChevronUp size={12}/> }
      </ClickOutside>
    );
  }
}

DropdownLink.contextTypes = {
  locale: PropTypes.string,
};

export default DropdownLink;



// WEBPACK FOOTER //
// ./src/main/components/output/DropdownLink.js